import React, { useContext } from "react";

import { Container, HeaderInfos, IconFE, NameUser, TextWelcome, TitlePage, IconButton, AvatarRing } from "./styles";
import { themes } from "../../design/colors";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";
import { View } from "react-native";
import UserContext from "../../context/user";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface HeaderProps {
    changePassword?: boolean;
    name?: string;
    type?: 'simple' | 'default';
    title?: string;
}

export default function Header({ changePassword, name, type = 'default', title }: HeaderProps) {
  const { user } = useContext(UserContext);
  const navigation = useNavigation();

  async function handleLogout() {
    await AsyncStorage.removeItem('@lmatransportes:role');
    await AsyncStorage.removeItem('@lmatransportes:accessToken');
    await AsyncStorage.removeItem('@lmatransportes:name');
    await AsyncStorage.removeItem('@lmatransportes:email');
    navigation.reset({
      index: 0,
      routes: [{ name: "Login" }],
    });
  }

  function handleBack() {
    navigation.goBack();
  }

  return (
    <Container>
      {type === 'default' ? (
        <>
            <AvatarRing>
              <Avatar
                rounded
                size="large"
                title={changePassword ? name?.substr(0, 2).toUpperCase() : user.initials_name}
                titleStyle={{ color: themes.colors.primary }}
                overlayContainerStyle={{
                  backgroundColor: themes.colors.white,
                }}
              />
            </AvatarRing>

            <HeaderInfos>
                <TextWelcome>{changePassword ? 'Bem vindo,' : 'Bem vindo de volta,'}</TextWelcome>
                <NameUser>{user.name}</NameUser>
            </HeaderInfos>

            <IconButton
              accessible
              accessibilityLabel="Sair"
              accessibilityRole="button"
              onPress={handleLogout}
            >
              <IconFE name="log-out" size={20} color={themes.colors.white} />
            </IconButton>
        </>
      ) : (
        <>
            <IconButton
              accessible
              accessibilityLabel="Voltar"
              accessibilityRole="button"
              onPress={handleBack}
            >
              <IconFE name="arrow-left" size={20} color={themes.colors.white} />
            </IconButton>
            <TitlePage>{title}</TitlePage>
            <View style={{ width: 40 }} />
        </>
      )}
    </Container>
  );
}
